import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "src/components/Table/Table";

import {
  getBookingsListAction,
  assignDriverAction,
  getCaptainsDropdownAction
} from "src/api/bookings";

export default function Bookings() {
  const dispatch = useDispatch();

  const { bookingsList } = useSelector(
    (state: any) => state.bookings || {}
  );

  const [captains, setCaptains] = useState<any[]>([]);

  const fetchData = async () => {
    await dispatch(getBookingsListAction({ pageNo: 1, pageSize: 10 }));
  };

  const fetchCaptains = async () => {
    const res = await dispatch(getCaptainsDropdownAction());
    setCaptains(res || []);
  };

  useEffect(() => {
    fetchData();
    fetchCaptains();
  }, []);

  const handleCaptainChange = async (row: any, captainId: string) => {
    await dispatch(
      assignDriverAction({
        bookingId: row.id,
        captainId,
      })
    );

    fetchData();
  };

  const openMap = (lat: string, lng: string) => {
    window.open(`https://www.google.com/maps?q=${lat},${lng}`, "_blank");
  };

  const columns = [
    { field: "parentName", headerName: "Parent", minWidth: 200 },
    { field: "parentPhone", headerName: "Phone", minWidth: 180 },
    { field: "childName", headerName: "Child", minWidth: 160 },
    { field: "grade", headerName: "Grade", minWidth: 100 },
    { field: "emergencyName", headerName: "Emergency Name", minWidth: 180 },
    { field: "emergencyPhone", headerName: "Emergency Phone", minWidth: 220 },
    { field: "address", headerName: "Address", minWidth: 140 },
    { field: "school", headerName: "School", minWidth: 140 },
    { field: "captain", headerName: "Captain", minWidth: 240 },
    { field: "status", headerName: "Status", minWidth: 180 },
  ];

  const actionContent = (column: string, row: any) => {
    if (column === "address") {
      return (
        <span
          style={{ color: "#1976d2", cursor: "pointer" }}
          onClick={() => openMap(row.addressLat, row.addressLng)}
        >
          View
        </span>
      );
    }

    if (column === "school") {
      return (
        <span
          style={{ color: "#1976d2", cursor: "pointer" }}
          onClick={() => openMap(row.schoolLat, row.schoolLng)}
        >
          View
        </span>
      );
    }

    if (column === "captain") {
      const selectedCaptain = captains.find(
        (c) => String(c.value) === String(row.driverId)
      );

      return (
        <FormControl size="small" sx={{ minWidth: 160 }}>
          <Select
            value={selectedCaptain ? selectedCaptain.value : ""}
            onChange={(e) =>
              handleCaptainChange(row, e.target.value as string)
            }
            displayEmpty
          >
            <MenuItem value="">
              <span style={{ color: "#9ca3af" }}>Assign Captain</span>
            </MenuItem>

            {captains.map((c) => (
              <MenuItem key={c.value} value={c.value}>
                {c.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      );
    }

    if (column === "status") {
      return (
        <Typography
          sx={{
            textAlign: "center",
            fontWeight: 500,
            color:
              row.status === "Assigned"
                ? "#117C39"
                : "#BA2222",
          }}
        >
          {row.status}
        </Typography>
      );
    }

    return null;
  };

  return (
    <Box mt={3} sx={{ pt: 1 }}>
      <Box
        sx={{
          "& .MuiTableContainer-root": {
            overflowX: "auto",

            // ✅ SCROLLBAR FIX (MATCH SCHOOLS)
            "&::-webkit-scrollbar": {
              height: "6px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#f1f5f9",
              borderRadius: "10px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#cbd5e1",
              borderRadius: "10px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#94a3b8",
            },
          },

          "& .MuiTable-root": {
            minWidth: "1500px",
          },
        }}
      >
        <CustomTable
          rows={bookingsList?.data || []}
          columns={columns}
          total={bookingsList?.total || 0}
          fetchData={() => {}}
          resetPagination={() => {}}
          action={actionContent}
        />
      </Box>
    </Box>
  );
}